<template>
  <div class='cardCheck'>
    <search-form size='medium'
                 labelWidth='90px'
                 :searchData="search.searchData"
                 :searchForm="search.searchForm"
                 :searchHandle="search.searchHandle">
    </search-form>

    <Table :TableParam="Table"
           v-loading="loading">
      <template v-slot:issuingType="{ item }">
        <span>{{ $label.getLabel($label.SendTypes, item.issuingType) }}</span>
      </template>
      <template v-slot:handle="row">
        <!-- 对于未激活的卡  通过页面操作时，只有动态充值卡才能有激活操作 -->
        <el-link type="primary"
                 @click="handleItem('激活',row.item)"
                 v-if="row.item.stateNo === 0 && row.item.cardNature === 2">激活</el-link>
        <el-divider direction="vertical"
                    v-if="row.item.stateNo === 0 && row.item.cardNature === 2"></el-divider>
        <el-link type="danger"
                 @click="handleItem('终止',row.item)"
                 v-if="row.item.stateNo === 0">终止</el-link>
        <el-divider direction="vertical"
                    v-if="type ===4"></el-divider>
        <el-link type="primary"
                 @click="handleItem('延期',row.item)"
                 v-if="row.item.stateNo === 3">延期</el-link>

        <el-divider direction="vertical"
                    v-if="type === 2"></el-divider>
        <el-link type="primary"
                 @click="handleItem('锁定',row.item)"
                 v-if="row.item.stateNo === 2">锁定</el-link>
        <el-divider direction="vertical"
                    v-if="type === 3"></el-divider>
        <el-link type="primary"
                 @click="handleItem('解锁',row.item)"
                 v-if="row.item.stateNo === 4">解锁</el-link>
        <!-- <el-divider direction="vertical"
                    v-if="row.item.stateNo === 2 || row.item.stateNo === 4"></el-divider>
        <el-link type="danger"
                 @click="handleItem('作废',row.item)"
                 v-if="row.item.stateNo === 2 || row.item.stateNo === 4">作废</el-link> -->
      </template>
      <template v-slot:Paging>
        <Paging @change="getItemList"
                :pager="pager" />
      </template>
    </Table>

    <service-dialog :show.sync="delayDialog.show"
                    @handle="delayDialog.confirm"
                    :title="delayDialog.title">
      <template v-slot:dialogContent>
        <div class="content">
          <span class="demonstration">有效期截止时间：</span>
          <el-date-picker v-model="delayDialog.validTime"
                          size="small"
                          type="date"
                          placeholder="结束日期"
                          value-format="yyyy-MM-dd"
                          :picker-options="delayDialog.pickerOptionsEnd">
          </el-date-picker>
        </div>
      </template>
    </service-dialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import SearchForm from '@/components/SearchForm'
import Table from '@/components/Table'
import Paging from '@/components/Paging'
import serviceDialog from '@/components/Dialog'

const stateProps = { label: 'text', value: 'value' }
const typeProps = { label: 'name', value: 'id' }
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    SearchForm,
    Table,
    Paging,
    serviceDialog
  },
  data () {
    // 这里存放数据
    return {
      loading: false,
      type: 1,
      pager: { // 翻页
        page: 1,
        rows: 10,
        count: 0
      },
      search: { // 搜索
        searchData: {
          interst: []
        }, // 返回的数据
        searchForm: [
          { type: 'Select', label: '状态：', prop: 'state', width: '180px', options: [], props: stateProps, change: row => '', placeholder: '请选择状态' },
          { type: 'Date', label: '有效期：', prop: 'validPeriod', placeholder: '请选择有效期' },
          { type: 'Date', label: '更新日期：', prop: 'updateDate', placeholder: '请选择更新日期' },
          { type: 'Select', label: '账户类型：', prop: 'cardTypeId', width: '180px', options: [], props: typeProps, change: row => '', placeholder: '请选择账户类型' },
          { type: 'Input', label: '账号：', prop: 'cardNo', placeholder: '请输入账号' },
          { type: 'Input', label: '会员ID：', prop: 'bindAccount', placeholder: '请输入会员ID' },
        ],
        searchHandle: [
          { label: '查询', type: 'primary', handle: () => this.searchHandleForm() },
          { label: '重置', handle: () => this.searchResetForm() }
        ]
      },
      cardNatureObj:{
        1: '不定额卡',
        2: '动态充值卡'
      },
      Table: { // 表格
        handle: true,
        data: [],
        column: [
          {
            prop: 'cardNo', label: '账号', type: 'event', handle: (res) => {
              this.$router.push({ path: 'cardCheckInfo', query: { id: res.id } })
            }
          },
          { prop: 'remaining', label: '余额' },
          { prop: 'issuingType', label: '发行方式', slot: true },
          { prop: 'bindAccount', label: '会员id' },
          { prop: 'bindAccountName', label: '账号名称' },
          { prop: 'validPeriod', label: '有效期' },
          { prop: 'state', label: '状态' },
          { prop: 'updateTime', label: '更新日期' }
        ]

      },

      delayDialog: { // 延后的弹窗
        show: false,
        title: '延期',
        confirm: this.delayDialogConfirm,
        oldValidTime: null,
        validTime: null,
        targetId: null,
        pickerOptionsEnd: {
          disabledDate: time => {
            const beginDateVal = this.delayDialog.oldValidTime
            if (beginDateVal) {
              return (
                time.getTime() < new Date(beginDateVal).getTime()
              )
            }
          }
        }
      }
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    // 点击搜索按钮
    async searchHandleForm () {
      await this.getItemList()
    },

    // 点击重置按钮
    searchResetForm () {
      this.search.searchData = {}
    },

    getItemList () {
      const { pager, search } = this
      this.loading = true
      const params = {
        pageNum: pager.page,
        pageSize: pager.rows,
        ...search.searchData
      }
      this.$http.getCardManageListApi(params)
        .then((res) => {
          this.loading = false
          if (res.status === 200) {
            this.pager.count = res.data.total
            this.Table.data = res.data.list.map((item) => ({
              ...item,
              bindAccount: (item.bindAccount || item.bindAccount === 'null') ? item.bindAccount : '-',
              remaining: item.cardNature==0 ? item.remaining : (item.remaining ? item.remaining : '-'),
              state: item.state.text,
              stateNo: item.state.value,
              denomination: item.denomination
            }))
          }
        })
    },
    // 点击 delayDialog 确定
    async delayDialogConfirm () {
      if (!this.delayDialog.validTime) {
        this.$message.warning('请选择结束日期')
      } else {
        await this.extensionCard()
        this.delayDialog.show = false
      }
    },
    // 点击各个按钮触发的函数，并分发调用接口
    handleItem (type, row) {
      const param = {}
      switch (type) {
        case '激活':
          param.id = row.id
          this.activationCard(param)
          break
        case '终止':
          param.id = row.id
          this.terminationCard(param)
          break
        case '锁定':
          param.id = row.id
          this.lockingCard(param)
          break
        case '作废':
          param.id = row.id
          this.invalidCard(param)
          break
        case '解锁':
          param.id = row.id
          this.unlockCard(param)
          break
        case '延期':
          const { id, validEnd } = row
          this.delayDialog.targetId = id
          this.delayDialog.oldValidTime = validEnd
          this.delayDialog.validTime = validEnd
          this.delayDialog.show = true
          break
      }
    },
    // 延期卡
    async extensionCard () {
      const param = {
        id: this.delayDialog.targetId,
        validEnd: this.delayDialog.validTime
      }
      await this.$http.extensionCard(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success(res.msg)
            this.searchHandleForm()
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    // 激活卡
    activationCard (param) {
      this.$http.activationCard(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('激活成功')
            this.searchHandleForm()
          }
        })
    },

    // 终止卡
    terminationCard (param) {
      this.$http.terminationCard(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('终止成功')
            this.searchHandleForm()
          }
        })
    },

    // 锁定卡
    lockingCard (param) {
      this.$http.lockingCard(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('锁定成功')
            this.searchHandleForm()
          }
        })
    },

    // 作废卡
    invalidCard (param) {
      this.$http.invalidCard(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('作废成功')
            this.searchHandleForm()
          }
        })
    },
    // 解锁卡
    unlockCard (param) {
      this.$http.unlockCard(param)
        .then((res) => {
          if (res.status === 200) {
            this.$message.success('解锁成功')
            this.searchHandleForm()
          }
        })
    },
    // 获取状态
    getCardStates () {
      this.$http.getCardStates()
        .then((res) => {
          if (res.status === 200) {
            this.search.searchForm.forEach((item) => {
              if (item.label.includes('状态')) {
                item.options = res.data
              }
            })
          }
        })
    },
    // 卡类型
    getCardTypeList () {
      this.$http.getCardTypeList()
        .then((res) => {
          if (res.status === 200) {
            this.search.searchForm.forEach((item) => {
              if (item.prop == 'cardTypeId') {
                item.options = res.data
              }
            })
          }
        })
    },
    init () {
      this.getItemList()
      this.getCardStates()
      this.getCardTypeList()
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    this.init()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
::v-deep .content {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .pickerBorder {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  .pickerLeft {
    .el-input__inner {
      border: none;
    }
  }
  .el-input__inner {
    text-align: center;
  }
  .hideIcon {
    .el-input__inner {
      border: none;
    }
    .el-input__prefix {
      display: none;
    }
  }
}
</style>
